import { Backdrop, Box, CircularProgress } from "@mui/material";

interface BackDropLoadingProps {
  isLoading: boolean;
}

export const BackDropLoading = ({ isLoading }: BackDropLoadingProps) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <Box display={"flex"} justifyContent={"center"} p={3}>
        <CircularProgress />
      </Box>
    </Backdrop>
  );
};
